import { BaseModal } from "../BaseModal";
import { ModalSize } from "../BaseModal/types";

const message = "The asset has been updated successfully.";
const title = "Asset Updates";

import styles from "./changesConfirmedModal.module.css";

interface ChangesConfirmedModalProps {
  open: boolean;
  onClose: () => void;
}

export default function ChangesConfirmedModal({ open, onClose }: Readonly<ChangesConfirmedModalProps>) {
  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={title}
      size={ModalSize.SM}
      clickOutside
      slots={{
        bottomActions: (
          <button className={styles.continueButton} onClick={onClose}>
            Continue
          </button>
        ),
      }}
    >
      <p className={styles.content}>{message}</p>
    </BaseModal>
  );
}
